// Function to filter voucher details by month, year, voucher type, and reduce the amount
const filterAndReduceVoucherAmountByMonthlyAndVoucherType = (voucherDetailsList, targetMonth, targetYear, targetVoucherType) => {
    // Filter vouchers for the target month, year, and voucher type
    const filteredVouchers = voucherDetailsList.filter(voucher => {
        const voucherDate = new Date(voucher.voucherPurchaseDate);
        const voucherMonth = voucherDate.getMonth() + 1; // +1 because getMonth() returns zero-based index
        const voucherYear = voucherDate.getFullYear();
        const voucherTypeMatch = voucher.voucherType === targetVoucherType;
        const monthMatch = voucherMonth === targetMonth;
        const yearMatch = voucherYear === targetYear;
        return voucherTypeMatch && monthMatch && yearMatch;
    });

    // Reduce the amount of filtered vouchers
    const reducedAmount = filteredVouchers.reduce((total, voucher) => {
        return total + voucher.voucherAmount;
    }, 0);

    // Count of filtered vouchers
    const count = filteredVouchers.length;

    return { reducedAmount, count };
}

export default filterAndReduceVoucherAmountByMonthlyAndVoucherType;
